export default function getEnv(varName: string): string {
    const varFromWindow = ((window as any)[varName] || '').trim();
    const isVarFromWindowEmpty =
        varFromWindow.includes('$') || varFromWindow === '';
    return isVarFromWindowEmpty ? process.env[varName] : varFromWindow;
}
